module.exports = __webpack_public_path__ + "images/home/index/customers-logo-wall-7f76b15a9b2554694a1aa11ed6d11d3b.png";